export default __webpack_public_path__ + "static/media/passwordDetailRedIcon.b0f933bc.svg";